import React, { useState } from 'react';
import {
  Box, VStack, Input, Button, Text, Heading, Spinner, Alert, AlertIcon, Tag, TagLabel, Flex
} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';

// Funzione per mappare il rischio al colore di Chakra UI
const mapRiskToColor = (risk) => {
  switch (risk) {
    case 'ALTO':
      return { color: 'red.500', bg: 'red.50', label: 'Rischio MOLTO ALTO' };
    case 'MEDIO':
      return { color: 'orange.500', bg: 'orange.50', label: 'Rischio Medio' };
    case 'BASSO':
      return { color: 'yellow.500', bg: 'yellow.50', label: 'Rischio Basso' };
    case 'NESSUNO':
      return { color: 'green.500', bg: 'green.50', label: 'Nessun Rischio Notato' };
    default:
      return { color: 'gray.500', bg: 'gray.50', label: 'Sconosciuto' };
  }
};
const API_URL = `http://${process.env.REACT_APP_API_BASE_URL}/api/segnalazioni/`;


const CheckRisk = ({ navigate }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSearch = async () => {
    if (!phoneNumber.trim()) {
      setError('Inserisci un numero di telefono valido.');
      setResult(null);
      return;
    }

    setLoading(true);
    setError('');
    setResult(null);

    try {
      // Rotta API: GET /api/segnalazioni/rischio/:numero
      const response = await fetch(`${API_URL}/rischio/${phoneNumber.trim()}`);
      
      if (!response.ok) {
        throw new Error('Errore durante la ricerca del rischio.');
      }

      const data = await response.json();
      setResult(data);

    } catch (err) {
      console.error("API Error:", err);
      setError('Impossibile connettersi al server API o errore di rete.');
      setResult({ 
        classificazione_rischio: 'NESSUNO',
        segnalazioni_recenti: 0,
        tag_popolari: []
      });
    } finally {
      setLoading(false);
    }
  };

  const riskDetails = result ? mapRiskToColor(result.classificazione_rischio) : null;

  return (
    <VStack spacing={6} p={8} maxW="xl" mx="auto" w="full">
      <Heading size="lg" color="teal.600">Verifica Rapida Numero</Heading>
      <Text color="gray.600">Inserisci il numero di telefono per controllare il livello di rischio di truffa in tempo reale.</Text>

      <Flex w="full">
        <Input
          placeholder="Es: 3331234567"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          size="lg"
          variant="filled"
          borderRadius="lg"
          mr={2}
          type="tel"
        />
        <Button
          onClick={handleSearch}
          colorScheme="teal"
          size="lg"
          isLoading={loading}
          leftIcon={<SearchIcon />}
          borderRadius="lg"
        >
          Cerca
        </Button>
      </Flex>

      {error && (
        <Alert status="error" borderRadius="md">
          <AlertIcon />
          {error}
        </Alert>
      )}

      {loading && <Spinner size="xl" color="teal.500" />}

      {result && (
        <Box 
          w="full" 
          p={6} 
          borderRadius="xl" 
          boxShadow="xl" 
          bg="white"
          textAlign="left"
        >
          <Heading size="md" mb={4}>Risultato per {phoneNumber}</Heading>
          
          <VStack align="stretch" spacing={4}>
            <Box p={3} bg={riskDetails.bg} border="1px" borderColor={riskDetails.color} borderRadius="lg">
              <Text fontSize="sm" color="gray.600">Classificazione Rischio:</Text>
              <Text fontSize="2xl" fontWeight="bold" color={riskDetails.color}>
                {riskDetails.label}
              </Text>
            </Box>

            {result.classificazione_rischio !== 'NESSUNO' && (
              <>
                <Text>
                  Segnalazioni recenti nella nostra rete: 
                  <Text as="span" fontWeight="bold" ml={2} color="red.500">{result.segnalazioni_recenti}</Text>
                </Text>

                <Box>
                  <Text mb={2} fontWeight="medium">Tag Popolari (Segnalati):</Text>
                  <Flex wrap="wrap" gap={2}>
                    {result.tag_popolari && result.tag_popolari.length > 0 ? (
                      result.tag_popolari.map((tag, index) => (
                        <Tag key={index} size="lg" colorScheme="red" borderRadius="full">
                          <TagLabel>{tag}</TagLabel>
                        </Tag>
                      ))
                    ) : (
                      <Text as="i" color="gray.500">Nessun tag specifico trovato.</Text>
                    )}
                  </Flex>
                </Box>
              </>
            )}

            <Button 
              mt={4} 
              colorScheme="red" 
              variant="outline"
              onClick={() => navigate('report')}
            >
              Segnala questo numero
            </Button>
          </VStack>
        </Box>
      )}

      <Button 
        mt={4} 
        variant="link"
        colorScheme="teal"
        onClick={() => navigate('report')}
      >
        Non trovato? Aggiungi una segnalazione
      </Button>
    </VStack>
  );
};

export default CheckRisk;